// FutureLab
import PreviousSession from '../components/feedback/PreviousSessionMenu';

export function PreviousSessionPage() {
	return (
		<div className="mx-auto w-full md:w-7/8 lg:w-2/3 xl:w-1/2">
			<PreviousSession />
		</div>
	);
}
